import type { FaireProductEntity } from "../../entity_types/product";

export const p_3sgcu52n5s: FaireProductEntity = {
  token: "p_3sgcu52n5s",
  type: "product",
  name: "Evil Eye Bath Bomb",
  brandToken: "b_5tsipzrz4h",
  brandName: "DollyMoo",
  imageUrl:
    "https://cdn.faire.com/fastly/8b55098f261cb4fb7b388ef5f81f2d12f52f95e60d36bab1275b8a6af1760a5e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a561379a8bd8f57e786ee399f1e9d3b1f6e0abad2375269eb827bae144953e7b.jpeg",
    "https://cdn.faire.com/fastly/b71af033b6aa67b57a915d704210079f5acc30b033d6d77fd4f90fdaf51a197a.jpeg",
    "https://cdn.faire.com/fastly/b210d23cfb37ddd75e51e738ace6a62c43ea933969dc46e32d5352add33b4c93.jpeg",
    "https://cdn.faire.com/fastly/d29ddcfb675c62e149161a761d11733a454a842c06a271bb3b6d3806c92a41fd.jpeg",
  ],
  priceDollars: 6,
  description:
    "Honoring the DollyMoo lineage and ancestry, this Evil Eye Bath Bomb was created in memory of our beloved YiaYia. Keeping her Greek roots vibrant, YiaYia always made sure all of her loved ones were protected from negativity by giving each of us a blue bead talisman. We would love to share this love and protection with you, from the roots of our ancestry to yours.\n\n𝐇𝐚𝐧𝐝-𝐌𝐢𝐱𝐞𝐝 𝐈𝐧𝐠𝐫𝐞𝐝𝐢𝐞𝐧𝐭𝐬:\nBaking Soda, Citric Acid, Organic Cocoa Butter, Wild-Harvested Witch Hazel, Grape Seed Oil, Essential/Fragrance Oil Blend, Mica, Blue 1, Love & Magick.\n\n• 3.5oz\n\n• Paraben Free/Phthalate Free/Vegan\n\n𝐍𝐨𝐭𝐞:\nAppearance of this bath bomb may change over time due to the nature of this product. Have no worries! Some discoloration could happen from natural oils.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:21.011Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
